import { render, staticRenderFns } from "./CustomMask.vue?vue&type=template&id=582ea993&scoped=true"
import script from "./CustomMask.vue?vue&type=script&lang=js"
export * from "./CustomMask.vue?vue&type=script&lang=js"
import style0 from "./CustomMask.vue?vue&type=style&index=0&id=582ea993&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582ea993",
  null
  
)

export default component.exports